import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './lib/auth';
import Login from './pages/Login';
import Register from './pages/Register';
import AppShell from './components/AppShell';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import VehicleNew from './pages/VehicleNew';
import VehicleDetail from './pages/VehicleDetail';
import VehicleContract from './pages/VehicleContract';
import VehicleTerm from './pages/VehicleTerm';
import LeadPublicForm from './pages/LeadPublicForm';
import Partners from './pages/Partners';
import PartnerDetail from './pages/PartnerDetail';
import People from './pages/People';
import Expenses from './pages/Expenses';
import VehiclesReport from './pages/VehiclesReport';
import Settings from './pages/Settings';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function ProtectedBare({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/veiculos" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
          <Route path="/veiculos/novo" element={<ProtectedRoute><VehicleNew /></ProtectedRoute>} />
          <Route path="/veiculos/:id/editar" element={<ProtectedRoute><VehicleNew /></ProtectedRoute>} />
          <Route path="/veiculos/:id" element={<ProtectedRoute><VehicleDetail /></ProtectedRoute>} />
          <Route path="/veiculos/:id/contrato" element={<ProtectedBare><VehicleContract /></ProtectedBare>} />
          <Route path="/veiculos/:id/termo" element={<ProtectedBare><VehicleTerm /></ProtectedBare>} />
          <Route path="/p/lead/:token" element={<LeadPublicForm />} />
          <Route path="/socios" element={<ProtectedRoute><Partners /></ProtectedRoute>} />
          <Route path="/socios/:id" element={<ProtectedRoute><PartnerDetail /></ProtectedRoute>} />
          <Route path="/pessoas" element={<ProtectedRoute><People /></ProtectedRoute>} />
          <Route path="/despesas" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
          <Route path="/relatorio-veiculos" element={<ProtectedRoute><VehiclesReport /></ProtectedRoute>} />
          <Route path="/configuracoes" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
